export default __webpack_public_path__ + "static/media/silhouette-girl2.13378764.svg";